export const GuidePageUpsellCardsMetaData = [
  {
    name: 'Idea',
    blpName: 'Halloween',
    imgUrl: 'https://i.pinimg.com/564x/64/57/66/645766dce0f2de6782e0660b5c8cf717.jpg',
    imgUrlBlp: 'https://i.pinimg.com/564x/64/57/66/645766dce0f2de6782e0660b5c8cf717.jpg',
    imgWidth: 224,
    imgHeight: 297,
    notShowInPinPage: true,
    link: '/pinterest_celebrations/halloween-ideas/',
  },
  {
    name: 'Party',
    blpName: 'Halloween Party',
    imgUrlBlp: 'https://i.pinimg.com/564x/fc/ad/fe/fcadfe96547600391dcbb2247d1f8f6f.jpg',
    imgUrl: 'https://i.pinimg.com/originals/d7/ee/cc/d7eecc197254cb8c3c33afa457c4ba5e.png',
    imgWidth: 224,
    imgHeight: 297,
    link: '/pinterest_celebrations/halloween-parties/',
  },
  {
    name: 'Costumes',
    blpName: 'Halloween Costumes',
    imgUrl: 'https://i.pinimg.com/originals/16/1c/85/161c852618d98ee1b351a6543c9bb98e.png',
    imgWidth: 224,
    imgHeight: 297,
    link: '/pinterest_celebrations/halloween-costumes/',
  },
  {
    name: 'Craft',
    blpName: 'Halloween Crafts',
    imgUrl: 'https://i.pinimg.com/originals/f1/a2/3e/f1a23ef674c885f7fb50f7f2178e6e84.png',
    imgWidth: 224,
    imgHeight: 297,
    link: '/pinterest_celebrations/halloween-crafts/',
  },
];

export const GuidePageUsernameSlugToLocale = {
  // halloween US
  'pinterest_celebrations/halloween-crafts': 'en',
  'pinterest_celebrations/halloween-parties': 'en',
  'pinterest_celebrations/halloween-costumes': 'en',
  'pinterest_celebrations/halloween-ideas': 'en',
  // holiday US
  'pinterest_celebrations/christmas-how-to-guides-for-every-occasion': 'en',
  'pinterest_celebrations/winter-fashion-holiday-outfits-2019': 'en',
  'pinterest_celebrations/new-and-traditional-christmas-dinner-ideas': 'en',
  'pinterest_celebrations/all-the-whys-of-christmas-explained': 'en',
  'pinterest_celebrations/new-year-new-you': 'en',
  // holiday i18n
  'pinterestjp/クリスマスケーキのレシピ': 'ja',
  'pinterestfr/bricolage-de-noël': 'fr',
  'pinterestde/weihnachten-2019': 'de',
  'PinterestIT/natale-fai-da-te-decorazioni-e-ricette': 'it',
  'PinterestPhilippines/christmas-decor-ideas': 'PH',
  'pinterestbr/receitas-de-natal': 'BR',
  'pinterestindonesia/resep-natal': 'ID',
  'pinterestmx/navidad': 'es',
};

//=====================================================================
//  keep data here the same as GUIDE_PAGE_TITLE inside
//  /pinboard/libs/common/utils/metatag_title_utils.py
//=====================================================================

export const UnauthGuidePageMetaData = {
  '681802899776849035': {
    author: 'Pinterest México',
    date: '21 de noviembre de 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'Nuevas y tradicionales ideas de cena para la Navidad',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '563794447076728601' },
          { id: '681802831072022600' },
          { id: '441423200962042361' },
          { id: '449726712788549970' },
          { id: '708191110132512671' },
          { id: '387661480425032906' },
          { id: '823736588067522842' },
          { id: '364087951120352361' },
          { id: '700872760742474103' },
          { id: '758012181006835676' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          'La Navidad está a la vuelta de la esquina. Por tanto, es momento de empezar a planear la mejor manera de celebrar con tus seres queridos.',
      },
      {
        type: 'string',
        value:
          '¿Estás buscando la receta perfecta? Empieza por las ideas y recetas favoritas de tu familia, como aperitivos, el pavo de Navidad, bacalao o incluso  recetas veganas. ¡Pero hay más! En Pinterest, puedes descubrir también las mejores ideas de árboles de Navidad, decoración de mesas y proyectos de "hazlo tú mismo".',
      },
      {
        type: 'string',
        value:
          'Si estás buscando recetas rápidas, consejos para cocinar para muchas personas y más, Pinterest tiene todo lo que necesitas para pasar una Navidad inolvidable en 2019.',
      },
    ],
  },
  '605945393553241254': {
    author: 'Pinterest Indonesia',
    date: '21 November 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'Resep Hidangan Natal',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '843087992722868108' },
          { id: '839921399233114062' },
          { id: '503910645793465194' },
          { id: '315885361362910458' },
          { id: '843087992726738738' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          'Perayaan Natal tidak lengkap tanpa menikmati hidangan khas dan klasik bersama keluarga. Pastinya Anda hendak menghidangkan santapan yang terbaik, unik dan just lezat.',
      },
      {
        type: 'string',
        value:
          'Temukan kumpulan berbagai resep masakan untuk perayaan Natal Anda, seperti makanan pembuka Natal, makanan utama seperti ayam kodok, minuman atau koktail bertema Natal dan pastinya makanan penutup seperti kue atau puding, permen dan coklat.',
      },
      {
        type: 'string',
        value:
          'Dari menghias kue kering hingga membuat kue fruitcake klasik, berikut temukan lima inspirasi resep kue natal menarik, lezat dan mudah untuk diikuti, pas untuk memeriahkan perayaan natal Anda.',
      },
    ],
  },
  '394065104834660491': {
    author: 'Pinterest Brasil',
    date: '21 de novembro de 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'Do novo ao tradicional: as melhores ideias para sua Ceia de Natal',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '511158626449273574' },
          { id: '394065036146145819' },
          { id: '331436853810751196' },
          { id: '394065036146145867' },
          { id: '573505333791334212' },
          { id: '421719952590747156' },
          { id: '585116176559949042' },
          { id: '330310953908951980' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          'O Natal está quase aí, então já é hora de começar a se planejar para receber toda a família!',
      },
      {
        type: 'string',
        value:
          'Procurando pela receita perfeita para as festas de final de ano? Comece buscando ideias para o Natal e também com os pratos favoritos da família como: entradinhas para a ceia de Natal, o famoso bacalhau, a farofa especial de Natal e até drinks para os adultos. E as festividades não param por aí! No Pinterest, você também encontra as melhores ideias de árvores de Natal, decoração de mesa e todas as referências de faça você mesmo de Natal que você pode precisar.',
      },
      {
        type: 'string',
        value:
          'Para àqueles que estão buscando por receitas rápidas de Natal, saladinhas, pratos para família grandes ou mais ideias para receber com estilo, aqui estão as melhores dicas para planejar um Natal memorável em 2019.',
      },
    ],
  },
  '406238897577376847': {
    author: 'Pinterest Philippines',
    date: '21 November 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: '12 Christmas Decoration Ideas for 2019',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '406238828889739966' },
          { id: '438960294923191306' },
          { id: '406238828889740006' },
          { id: '406238828889388660' },
          { id: '406238828889388659' },
          { id: '406238828889388653' },
          { id: '406238828889388658' },
          { id: '406238828889388656' },
          { id: '406238828889388655' },
          { id: '406238828889388651' },
          { id: '406238828889388648' },
          { id: '777293216914457553' },
          { id: '406238828889388647' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          'It’s the most wonderful time of the year! Time to start planning your most memorable Christmas yet. This Christmas, make every room look as festive as possible with these jolly Christmas decoration ideas to make your season both merry and bright. From DIY Christmas decor to ideas for holiday hosting, we’ve chosen these 12 Pins to help spark your imagination. Maligayang Pasko!',
      },
    ],
  },
  '842314005246081570': {
    author: 'Pinterest Italia',
    date: '21 novembre 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'Natale fai-da-te',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '523191681713701854' },
          { id: '832251206115582173' },
          { id: '842313936541564945' },
          { id: '17240411060310831' },
          { id: '842313936541586245' },
          { id: '617204323909779672' },
          { id: '7248049381091441' },
          { id: '777293216914457553' },
          { id: '396176098468450396' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          "Il periodo più bello dell'anno è alle porte! Iniziate a preparare il Natale più memorabile di sempre. E se è un Natale fai da te, ancora meglio. Dagli addobbi natalizi più originali a ricette facili e deliziose, abbiamo per voi moltissime idee per stimolare la vostra immaginazione e passare un buon Natale in allegria. Questo Natale potete ravvivare la vostra tavola con decorazioni personalizzate e stupire amici e parenti con creazioni facili ma di effetto. Non sapete cosa cucinare per la cena della vigilia o per il pranzo di Natale? Abbiamo a disposizione per voi dei menù completi facili e veloci per tutti i gusti con tanto di ricette tradizionali o alternative. È tempo di regali, di canti e di canzoni di Natale, di mercatini, di addobbi natalizi e di auguri. Questo Natale, lasciatevi ispirare.",
      },
    ],
  },
  '458452505757193914': {
    author: 'Pinterest Deutschland',
    date: '21. November 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: '15+ Ideen für ein gemütliches Weihnachten',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '856739529092425600' },
          { id: '530087818640915488' },
          { id: '489344315758878059' },
          { id: '483433341234745183' },
          { id: '458452437069341125' },
          { id: '727823989753947890' },
          { id: '792070653191018109' },
          { id: '810929476631298284' },
          { id: '767863805199966021' },
          { id: '426856870928908833' },
          { id: '458452437069341116' },
          { id: '458452437069341115' },
          { id: '458452437069341114' },
          { id: '458452437069341113' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          'Advent, Advent, ein Lichtlein brennt… . Der Dezember ist die Zeit der Lichter und Kerzen. Der Duft von Gewürzen und die Sehnsucht nach Gemütlichkeit liegen in der Luft. Damit zwischen Geschenke besorgen und der Weihnachtsplanung kein Stress aufkommt, ist es wichtig, sich genügend Momente für ein gemütliches Weihnachten zu nehmen. Dies kann für jeden Menschen etwas unterschiedliches bedeuten. Manchmal sind es natürliche Materialien, schlichte Blockkerzen, die Farben weiß und rot und frische Tannenzweige, die dafür sorgen, dass eine solche vorweihnachtliche Gemütlichkeit aufkommt. In anderen Fällen bedeutet ein gemütliches Weihnachten auch, sich auf den traditionellen Filme-Marathon vorzubereiten, sich in die Lieblingsdecke einzukuscheln und es sich vor dem Fernseher mit den Weihnachtsklassikern gemütlich zu machen.',
      },
      {
        type: 'string',
        value:
          'Hier sind einige Ideen, die deine Winterzeit verschönern können und dich zu neuen (oder aber auch alten) Traditionen inspirieren. Von ausgefallenen Adventskranz-Ideen, die auch einfach umzusetzen sind, bis hin zu Rezeptideen für einen neuen Blick auf die klassische heiße Schokolade — mit diesen Ideen wird das kommende Weihnachtsfest noch besinnlicher und gemütlicher.',
      },
      {
        type: 'string',
        value: 'Viel Spaß beim erkunden und entdecken!',
      },
    ],
  },
  '568509221651069774': {
    author: 'Pinterest France',
    date: '21 novembre 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'Les bricolages de Noël',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '568509152963240335' },
          { id: '793407659331166430' },
          { id: '756675174865159702' },
          { id: '198158452335120489' },
          { id: '422634746277925969' },
          { id: '57913545195417960' },
          { id: '568509152963238012' },
          { id: '763008361846057311' },
          { id: '568509152963230124' },
          { id: '132011832815035656' },
          { id: '568509152963552225' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          "Les fêtes de fin d’année approchent à grands pas ! Il est temps de s’attaquer à sa to-do list, en commençant par le bricolage de Noël. À l'occasion de cette période magique, réalisez une déco unique à prix doux et exposez avec fierté vos créations faites maison, que ce soit pour décorer votre sapin, votre intérieur ou votre table du Réveillon de Noël.",
      },
      {
        type: 'string',
        value:
          "Calendrier de l'Avent, sapin et boules de Noël, guirlandes, bougies et lampions, pliage de serviettes, couronnes de Noël,...il y en a pour tous les goûts et tous les niveaux ! Découvrez nos idées DIY et activités manuelles qui réjouiront toute la famille et impressionerons le Père Noël lui-même. Des idées simples, économiques et écologiques pour un Noël 100% personnalisé !",
      },
    ],
  },
  '407294428740042481': {
    author: 'Pinterest Japan',
    date: '2019年11月21日',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: '少ない道具と時間でおしゃれなクリスマスケーキを手作りするレシピ 12 選',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '407294360053144026' },
          { id: '407294360053144118' },
          { id: '407294360053144062' },
          { id: '407294360053144523' },
          { id: '407294360053144461' },
          { id: '407294360053144207' },
          { id: '361343570103827789' },
          { id: '407294360053144486' },
          { id: '486740672225813385' },
          { id: '407294360053500051' },
          { id: '215258057170373619' },
          { id: '407294360053500173' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          'ケーキや洋菓子の手作りといえば、材料と道具とスキルが必要で「ハードルが高い」と感じる人も多いのではないでしょうか？でも実は、家にある道具やスーパーで手に入るお菓子や材料で簡単にプロ顔負けのクリスマスケーキを作れるってご存知でしたか？これならデパートやパティシエのケーキを並んで、しかも高いお金を払って買わなくても、友人や子供も大喜びのクリスマスケーキを最高のプレゼントとして用意することができます。定番のブッシュドノエル、クリスマスツリーやリースがモチーフのケーキなど、見た目も華やかなケーキを飾り付け次第で誰でも簡単に作れる、目から鱗のレシピをご紹介します！',
      },
    ],
  },
  '767300923952707313': {
    author: 'Pinterest Celebration',
    date: 'November 21, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'New Year, New You: Inspiration for Your New Year’s Resolutions and More',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          {
            id: '459015387022116326',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Your New Year's Eve outfits have been selected. You know where you'll be when you watch the New Year's ball drop as New Year's Eve fireworks light up the sky. But what will your New Year's goals be for 2020 be? And what heartfelt or funny New Year's greetings will you send to friends and loved ones in celebration of the holiday?",
              },
            ],
          },
        ],
      },
      {
        sectionName: '',
        sectionPins: [
          {
            id: '739364463808848518',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Here, find some of the best New Year's sayings for everything from your personal resolutions for 2020 to what to say for your New Year's Eve party toast and what to include in your New Year wishes messages. And for those looking for New Year's Eve party ideas, you can even incorporate these sayings into your New Year's Eve decorations.",
              },
            ],
          },
        ],
      },
      {
        sectionName: "Inspirational New Year's Quotes",
        sectionPins: [
          {
            id: '56224695335678554',
          },
        ],
        endText: [
          {
            type: 'string',
            value:
              'From authors and actors to philosophers and poets, here are some of the most inspirational quotes for the New Year for any occasion…',
          },
        ],
      },
      {
        sectionName: "...for Making New Year's Resolutions and Finding New Year Resolution Ideas",
        sectionPins: [
          {
            id: '747386500644843386',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Not sure what your New Year goals for 2020 should be? Here's what some wise souls have had to say about creating (and sticking to) resolutions and making lasting changes in your life.",
              },
            ],
          },
          {
            id: '133137732721825947',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "\"For a change, don't add new things in your life as a New Year's resolution. Instead, do more of what's already working for you and stop doing things that are time-waste.\" ―Salil Jha, Indian-born American poet and author.",
              },
            ],
          },
          {
            id: '509821620314459865',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  '"Your success and happiness lies in you. Resolve to keep happy, and your joy and you shall form an invincible host against difficulties." —Helen Keller, American educator, advocate for the blind and deaf, cofounder of the ACLU, and author of "The Story of My Life" and other works',
              },
            ],
          },
          {
            id: '570831321516250019',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  '"If you don\'t like something, change it. If you can\'t change it, change your attitude." —Dr. Maya Angelou, best-selling American author, poet, singer, and civil rights activist',
              },
            ],
          },
          {
            id: '728316570971838227',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  '"The secret of change is to focus all of your energy, not on fighting the old, but on building the new." —Socrates, Greek philosopher',
              },
            ],
          },
        ],
      },
      {
        sectionName: "...for New Year's Cards and Happy New Year Wishes for Friends",
        sectionPins: [
          {
            id: '599752875354241595',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Whether you're planning to send your friends and family greeting cards ahead of the holiday or texts on New Year's Eve right as the clock strikes midnight, here are some great quotes to celebrate the new year and all of the wonderful possibilities it may bring.",
              },
              {
                type: 'string',
                value:
                  '"Cheers to a new year and another chance for us to get it right." —Oprah Winfrey, American media executive, actress, philanthropist, talk show host, and Golden Globe Award and Emmy Award winner',
              },
            ],
          },
        ],
        endText: [
          {
            type: 'string',
            value:
              '"Write it on your heart that every day is the best day in the year." —Ralph Waldo Emerson, American essayist, philosopher, and poet',
          },
          {
            type: 'string',
            value:
              '"What a wonderful thought it is that some of the best days of our lives haven\'t even happened yet." —Anne Frank, German-born Jewish author of the “The Diary of Anne Frank,” one of the top 10 most-read books worldwide',
          },
          {
            type: 'string',
            value:
              '"You know how I always dread the whole year? Well, this time I\'m only going to dread one day at a time." —Charlie Brown, the famously anxious character of American cartoonist Charles M. Schulz\'s comic "The Peanuts"',
          },
        ],
      },
      {
        sectionName: "...for Making a New Year's Toast",
        sectionPins: [
          {
            id: '71846556541564063',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "With everyone gathered together with their New Year's Eve drinks in hand, now it's your big moment. What will you say? For those looking for ideas for your New Year's Eve dinner toast, turn to these celebrated writers and activists for inspiration.",
              },
            ],
          },
          {
            id: '222576406570215291',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  '"And now we welcome the new year. Full of things that have never been." —Rainer Maria Rilke, Austro-German poet and author',
              },
              {
                type: 'string',
                value:
                  '"It is never too late to be what you might have been." —George Eliot, Enlish Victorian-era poet, journalist, and author of such classics as "Middlemarch"',
              },
            ],
          },
          {
            id: '741827369848959446',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  '"The New Year is a painting not yet painted; a path not yet stepped on; a wing not yet taken off! Things haven\'t happened as yet! Before the clock strikes twelve, remember that you are blessed with the ability to reshape your life!" ―Mehmet Murat İldan, Turkish playwright and novelist',
              },
            ],
          },
          {
            id: '837951074400975630',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  '"To see the first sun rise in the New Year is the most sacredness of existence." ―Lailah Gifty Akita, Ghanian founder of Smart Youth Volunteers Foundation and author of "Pearls of Wisdom: Great Mind" and more',
              },
            ],
          },
          {
            id: '503136589622348651',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  '"On New Year\'s Eve the whole world celebrates the fact that a date changes. Let us celebrate the dates on which we change the world." ―Akilnathan Logeswaran, German activist, "Forbes 30 Under 30 — Europe," and founder of Stand Up for Europe',
              },
            ],
          },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value: '',
      },
    ],
  },
  '767300923952703192': {
    author: 'Pinterest Celebration',
    date: 'November 7, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'All the ways of Christmas... Explained',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          {
            id: '221872719128210688',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Why is Christmas important, why do we put up Christmas trees, and why was celebrating Christmas once against the law in America? These are just a few of some of the most frequently asked questions about the holiday. Whether you’re looking for Christmas trivia to share with friends or you’re just plain curious, we’ve got the answers to these questions and more.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Why are red and green Christmas colors?',
        sectionPins: [
          {
            id: '228135537360104283',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'The origins of including the signature bright red and green holly plant as part of winter holiday celebrations can be traced back to Winter Solstice celebrations in ancient Roman times. But historians say that it\'s Coca-Cola we can really thank for the popularization of these two colors. In 1931, an artist hired by the company created a rendering of Santa Claus—dressed in red and green—that\'s become accepted as "the" Santa Claus. Today, that depiction of Santa, along with the colors, has now become synonymous with Christmas.',
              },
            ],
          },
          {
            id: '767300855247955033',
          },
        ],
      },
      {
        sectionName: 'Why do we have Christmas trees?',
        sectionPins: [
          {
            id: '91620173657128376',
            guidePageDescription: [
              {
                type: 'string',
                value: 'Why do we decorate Christmas trees?',
              },
              {
                type: 'string',
                value:
                  'Though evergreen plants and trees—those that stay alive all year—have been an important part of annual celebrations for many cultures throughout time, dating back to early Egyptian, Roman, Celtic, and Viking eras, historians usually credit Christian Germans with the practice of having Christmas trees. While some date the earliest Christmas trees to the 7th century, others say they may have originated more recently—in the 16th century, with Protestant reformer Martin Luther believed to have been the first to decorate a tree by adding lit candles to its branches. Historians attribute hanging ornaments to English traditions that began as early as the late 1700s with King George III and his German wife Charlotte and later became popularized under the influence of Queen Victoria, with the tradition making its way to America in the 1800s.',
              },
            ],
          },
          {
            id: '817192294863685209',
          },
          {
            id: '138907969728432950',
          },
          {
            id: '613896992937167563',
            guidePageDescription: [
              {
                type: 'string',
                value: '...and why upside down Christmas trees?',
              },
              {
                type: 'string',
                value:
                  "Upside down Christmas trees may sound like a modern fad, but, in fact, the tradition may date as far back as the 7th century, according to some. It's believed that at the time the ritual was intended to symbolize the Holy Trinity. These days, hanging trees has become trendy with everyone from big name retailers and celebrities to regular people looking for creative ways to decorate for the holidays.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Why are there 12 days of Christmas?',
        sectionPins: [
          {
            id: '24277285477781270',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'You\'ve probably heard the popular holiday, but what are the 12 days of Christmas all about? Not to be confused with Advent, which begins before Christmas, the 12 days of Christmas kick off with December 25 as the first day of Christmas, and continue through until a holiday known as Three Kings\' Day or the Epiphany (which means "revelation" in Greek) on January 6. Some say the 12 days are meant to represent the amount of time it took for the Three Wise Men to journey to visit baby Jesus. Each of the 12 days is a unique celebration or remembrance of various events, saints, and religious figures like Mary, the mother of Jesus.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Why do we give gifts on Christmas?',
        sectionPins: [
          {
            id: '81275968261441735',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'While some tie the tradition of giving presents to the Three Wise Men bringing offerings of gold, frankincense, and myrrh to baby Jesus in the Bible, historians trace the custom back to the ancient Roman festival Saturnalia, in which those celebrating the Winter Solstice holiday would drink and give each other small items, like pottery, treats, and candles. Another historical figure who may have had an influence is Saint Nicholas, the man who inspired Santa Claus, a 4th-century Christian bishop who gave gifts to poor children. Giving gifts at Christmas took off as a trend in the United States starting in the 1800s.',
              },
            ],
          },
          { id: '201606520799399955' },
          { id: '265360603029782524' },
          { id: '114701121747397710' },
          { id: '811422057832313208' },
        ],
      },
      {
        sectionName: 'Why was Christmas banned in America?',
        sectionPins: [
          {
            id: '447826756693847061',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'The early Puritans who first came to America in the 1600s were decidedly anti-Christmas, a day they often referred to as "Foolstide." They decried its pagan roots, tied to the ancient Roman Saturnalia, and saw no direct connection between the holiday and the Bible. When Puritans in England overthrew King Charles I in England in 1647, they banned the holiday there—marking it instead as a day for fasting and humility. That sentiment was shared by Puritans in America and as early as 1659, a law passed in Massachusetts prohibiting all Christmas celebrations and remained in effect until the 1680s. As late as 1802, members of the House of Representatives worked on Christmas Day—not observing it as a day off. ',
              },
              {
                type: 'string',
                value:
                  'Over time, public opinion evolved with the publication of the now celebrated Clement Clarke Moore poem, "A Visit from St. Nicholas" (more commonly known as "Twas the Night Before Christmas") and the day eventually became established as a public holiday in the state of Alabama in 1836 and as a federal holiday in 1870.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Why do we celebrate Christmas?',
        sectionPins: [
          {
            id: '370491506843411261',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Mid-winter celebrations, such as Saturnalia mentioned above, date back to ancient times long before the arrival of Jesus and the Christian religion. In the nascent stages of Christianity, Easter, which celebrates the resurrection of Jesus, was the central holiday of the religion. It was only in the 4th century that leaders decided to begin observing the birth of Christ.',
              },
              {
                type: 'string',
                value: 'Why is Christmas on December 25th?',
              },
              {
                type: 'string',
                value:
                  'Why is Christmas in December and on the 25th, you ask? Historians believe that when introducing the holiday—what was then called the Feast of the Nativity—in the 4th century, Pope Julius I picked the date of December 25 to incorporate the traditions of the original pagan holiday Saturnalia, which took place at the same time, into this one new celebration.',
              },
            ],
          },
          {
            id: '483362972504553250',
            guidePageDescription: [
              {
                type: 'string',
                value: 'Why is Christmas called "Xmas"?',
              },
              {
                type: 'string',
                value:
                  'The "X" in "Xmas" is the symbol for the Greek letter "chi" and in Greek Christ begins with chi. It was Roman Emperor Constantine the Great who popularized the usage of chi as shorthand for Christ back in the 300s and early Christians used the symbol X as a way to indicate their membership in the church. As early as 1021 abbreviations using "X" and "mas" came into use, giving us the unique spelling or shorthand: "Xmas." ',
              },
            ],
          },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value: '',
      },
    ],
  },
  '767300923952703178': {
    author: 'Pinterest Celebration',
    date: 'November 7, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'Winter Fashion 2019 Guide to Party Clothes, Holidays Outfits, and More',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '152981718568335862' },
          { id: '300615343879330545' },
          { id: '596023331917464670' },
          { id: '631066966513199488' },
          { id: '745838388267495016' },
          { id: '51158145750691309' },
          { id: '213921051034071088' },
          { id: '500814421063611743' },
          { id: '478437160393452597' },
          { id: '59180182589824712' },
          { id: '781022760358705021' },
          { id: '286471226283305779' },
          { id: '218846863129365082' },
          { id: '463659724124015023' },
          { id: '833658581004013088' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          "Holiday party planning season is here, which means it's also time to pick out the perfect party clothes. Wondering what to wear to a company Christmas party, what to wear to a casual Christmas party, or what to wear to a house party with friends and family at New Year's? Check out these popular winter styles for inspiration for holiday outfits for women and men, including recommendations for Christmas party outfits, holiday suits, holiday dresses, Christmas costume ideas, and more.",
      },
      {
        type: 'string',
        value:
          "Are ugly Christmas sweaters in or out? What are the most popular colors of the season—classic holiday red, gold, green, and silver or little black holiday dresses? What type of women's Christmas shirts are generating the most buzz? Start finding inspiration for all of your holiday party outfits by taking a look at these 2019 Christmas trends.",
      },
    ],
  },
  '767300923952703194': {
    author: 'Pinterest Celebration',
    date: 'November 7, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'New and Traditional Christmas Dinner Ideas',
    subsections: [
      {
        sectionName: '',
        sectionPins: [
          { id: '839780661749570065' },
          { id: '261842165822489108' },
          { id: '199988039690290399' },
          { id: '757519599800273489' },
          { id: '167055467413863250' },
          { id: '394487248607819598' },
          { id: '478789004132016123' },
          { id: '29414203804851087' },
          { id: '205758276712355780' },
          { id: '558164947564936782' },
          { id: '61150507441591356' },
          { id: '25473554127949486' },
          { id: '858217272718833833' },
          { id: '125749014579866142' },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          "What's the recipe for the perfect holiday party? It begins with finding Christmas dinner ideas and Christmas recipes for everyone's favorite holiday foods, like Christmas appetizers, main courses like Christmas ham, Christmas salad, Christmas punch and holiday cocktails for the adults, along with cookies, candy, cakes and other classic Christmas desserts. But it doesn't stop there. There's Christmas dinnerware, napkin folds, tablescapes, and more holiday decorating ideas to consider. And what will be on your holiday playlist as your guests start to arrive?",
      },
      {
        type: 'string',
        value:
          "Whether you're looking for easy Christmas recipes, baking ideas, tips for cooking for a crowd, or other hosting tips, here are all the ingredients you need to put together a successful Friendsmas, Christmas Eve dinner, traditional Christmas dinner, and other holiday meals that everyone will remember for years to come.",
      },
    ],
  },
  '767300923952703244': {
    author: 'Pinterest Celebration',
    date: 'October 7, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'Christmas how-to guides for every occasion',
    introList: [
      {
        type: 'string',
        value:
          'From the humorous to the practical, here are our favorite holiday hacks for becoming the go-to how-to expert about everything from keeping  Christmas tree fresh to how to wrap a cat for Christmas.',
      },
    ],
    subsections: [
      {
        sectionName: 'How to wrap your cat for Christmas 101',
        sectionPins: [
          {
            id: '842525042767704854',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Over the last decade, a new, Internet-driven Christmas-wrapping trend has emerged that involves wrapping something other than presents—cats. Certain successfully wrapped cats (and the humans responsible for the wrapping) have even become viral sensations with one video ("How To Wrap A Cat For Christmas") earning 12 million views since being uploaded in December 2009. Another popular follow-up act ("How to wrap your Cat for Christmas 101") has earned less than half a million views, but it\'s only been around for two years, so there\'s time.',
              },
            ],
          },
          {
            id: '751467887802930940',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "As to what's involved, you'll need the same basic materials used for wrapping presents: a big roll of holiday paper, scissors, and tape. The secret ingredient is a cat that's willing to participate. To get started, have your agreeable cat sit on a sheet of wrapping paper and begin taping, leaving an opening for the head. For the final touch, place a bow on top of your cat. If all goes well, your kitty will be as cozy as if wrapped up in a blanket.",
              },
            ],
          },
          {
            id: '381187555959261306',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Now as for how to keep cats out of your Christmas tree? That's a different story.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'How to keep a Christmas tree fresh',
        sectionPins: [
          {
            id: '20758848262567974',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Wondering how long will a Christmas tree last? Most can survive five weeks or more. With the right care—including knowing how to water Christmas trees properly—yours may make it even longer.',
              },
              {
                type: 'string',
                value:
                  "For starters, you want to pick the healthiest tree possible from a local farm (that means less miles traveled to reach your home and less exposure to the elements) that's all green or has the least amount of dry brown needles. Tip: When you touch the branches, no needles should fall off.",
              },
            ],
          },
          {
            id: '570760952772117659',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Now you're ready for your next challenge: Learning how to keep Christmas trees alive. Just as you should cut the stems of flowers before placing them in water, you should make sure the Christmas tree seller trims the base of your trunk before you haul it off the lot. For extra precaution, wrap your tree in a tarp to protect it during the ride home. Once you arrive, cut another inch off the bottom, then place the tree directly in your tree stand with a water holder. Now your job for the rest of the holidays is watering your Christmas tree every day. The entire base of the tree should be sitting in water at all times. A rule of thumb: The typical Christmas tree needs about one quart of water per inch of its diameter, so expect a four-inch-diameter trunk to need a gallon of water per day.",
              },
            ],
          },
        ],
        endText: [
          {
            type: 'string',
            value:
              "Now: how to dispose of a Christmas tree? Take it down before it's dry (no needles all over the house) and see if your city offers a Christmas tree recycling program to turn your tree into mulch for your yard.",
          },
        ],
      },
      {
        sectionName: 'How to fix pre-lit Christmas tree lights',
        sectionPins: [
          {
            id: '122793527326338033',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Pre-lit Christmas trees are supposed to help address some of the common how-to conundrums that arise with traditional Christmas trees, such as not knowing how to put up Christmas lights on a tree or how to string Christmas lights. But occasionally, these alternative trees can also pose problems if the lights stop working properly. For pointers on how to troubleshoot Christmas lights on a tree try the following:',
              },
              {
                type: 'list',
                value: [
                  {
                    type: 'string',
                    value:
                      'Make sure all plugs are connected properly and that the power cord is plugged in.',
                  },
                  {
                    type: 'string',
                    value: 'Check the on/off button to make sure it is on.',
                  },
                  {
                    type: 'string',
                    value: 'Check the fuses and replace any as needed.',
                  },
                  {
                    type: 'string',
                    value:
                      'Make sure all the bulbs are tightly inside each socket, with none broken or missing; unplug the tree and replace any as needed.',
                  },
                  {
                    type: 'string',
                    value: 'If nothing else works, you can test each bulb with a bulb tester.',
                  },
                  {
                    type: 'string',
                    value:
                      "For how to fix christmas lights without a tester, you'll need to unplug the tree and remove each bulb one at a time from the string of lights that isn't working, checking the wires at the bottom of the bulb holders and making sure each is properly aligned to its holder. If a wire is missing or too short, you'll need to replace the bulbs.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Christmas Decorations How-Tos',
        sectionPins: [
          {
            id: '79868593378001965',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Want to have yourself a merry DIY Christmas? There is a seemingly endless supply of how-to guides for making Christmas decorations of all kinds, from the funny—how to make ugly Christmas sweaters, to the elaborate—how to make a Christmas village display, to the more traditional—how to make Christmas stockings.',
              },
            ],
          },
          {
            id: '80220437098312966',
          },
          {
            id: '56787645292058881',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'For a quick and simple idea, learn how to fold napkins for Christmas—one of the easiest options is figuring out how to fold elf hat napkins. Give it a try:',
              },
              {
                type: 'list',
                value: [
                  {
                    type: 'string',
                    value:
                      'Place a green square napkin (such as 16 inches by 16 inches) on a flat surface',
                  },
                  {
                    type: 'string',
                    value: 'Fold the napkin in half horizontally',
                  },
                  {
                    type: 'string',
                    value:
                      'Pinch the bottom middle of the folded napkin with one hand, and begin rolling the napkin into a cone shape that comes to a point on one side and leaves an opening at the base',
                  },
                  {
                    type: 'string',
                    value:
                      'At the open base, fold the fabric back to create the signature brim of your elf hat ',
                  },
                ],
              },
            ],
          },
          {
            id: '350436414755407086',
          },
        ],
      },
      {
        sectionName: 'How to write Christmas cards',
        sectionPins: [
          {
            id: '114278909281380956',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "For those wondering how to write a Christmas letter, there's no wrong way to do it if it comes from the heart. One common practice is to use the timing of the holiday, near the end of the calendar year, to reflect on:",
              },
              {
                type: 'list',
                value: [
                  {
                    type: 'string',
                    value:
                      'Major milestones from throughout the year, such as graduating, receiving a promotion, starting a new sport, or moving to a new home',
                  },
                  {
                    type: 'string',
                    value: 'Activities you enjoyed together as a family',
                  },
                  {
                    type: 'string',
                    value: "The experiences you're most grateful for Your hopes for the year ahead",
                  },
                ],
              },
            ],
          },
          {
            id: '255579347577528411',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Other important things to consider when putting together a Christmas letter include:',
              },
              {
                type: 'string',
                value:
                  'How to address Christmas cards: If you create a Christmas card that you plan to mail or email to all of your friends and family, you may want to use a general greeting, such as:',
              },
              {
                type: 'list',
                value: [
                  {
                    type: 'string',
                    value: 'Season’s greetings',
                  },
                  {
                    type: 'string',
                    value: 'Dear loved ones',
                  },
                  {
                    type: 'string',
                    value: 'Dear friends and family',
                  },
                  {
                    type: 'string',
                    value: 'Happy holidays',
                  },
                  {
                    type: 'string',
                    value: 'Merry Christmas',
                  },
                ],
              },
            ],
          },
          {
            id: '552324341797720468',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'How to sign Christmas cards: Wondering how to sign a Christmas card? Again, anything heartfelt is appropriate here. Common sign-offs include:',
              },
              {
                type: 'list',
                value: [
                  {
                    type: 'string',
                    value: 'Best wishes',
                  },
                  {
                    type: 'string',
                    value: 'Happy holidays',
                  },
                  {
                    type: 'string',
                    value: 'Seasons greetings',
                  },
                  {
                    type: 'string',
                    value: 'Merry Christmas',
                  },
                  {
                    type: 'string',
                    value: 'Have a Merry Christmas and a Happy New Year!',
                  },
                  {
                    type: 'string',
                    value: 'Love',
                  },
                  {
                    type: 'string',
                    value: 'All our love',
                  },
                  {
                    type: 'string',
                    value: 'Yours truly',
                  },
                ],
              },
              {
                type: 'string',
                value:
                  "If you're mailing the same Christmas letter to all of your friends and family, you may want to add a personalized hand-written note at the bottom of your card for each individual recipient.",
              },
            ],
          },
          {
            id: '703757879249150178',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "How to make a Christmas card: When taking the time to send someone a warm greeting at the holidays, it's the thought that counts. Whether you end up opting for a hand-written note, a typed up letter paired with your favorite family photos, or putting together your own family photo collage Christmas card, you can't go wrong.",
              },
            ],
          },
        ],
      },
    ],
  },
  '767300923952672844': {
    author: 'Pinterest Celebration',
    date: 'October 7, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: "10 Halloween Crafts You'll Want to Pin (and Make)",
    endText: [
      {
        type: 'string',
        value:
          "Feeling inspired? Start Pinning, then get crafting. And don't forget to Pin your Halloween creations on Pinterest.",
      },
      {
        type: 'string',
        value:
          'For more ways to celebrate, check out our other Halloween guides, curated from the tens of millions of holiday-themed Pinterest boards created by our 300 million strong community:',
      },
      {
        type: 'list',
        value: [
          {
            type: 'link',
            text: '11 Best Halloween Party Games, Treats, and More',
            url: '/pinterest_celebrations/halloween-parties/',
          },
          {
            type: 'link',
            text: 'Top 13 Halloween Ideas from Pinterest',
            url: '/pinterest_celebrations/halloween-ideas/',
          },
          {
            type: 'link',
            text: '13 Creative Halloween Costume Ideas for 2019',
            url: '/pinterest_celebrations/halloween-costumes/',
          },
        ],
      },
    ],
    subsections: [
      {
        sectionName: 'Halloween activities for kids',
        sectionPins: [
          {
            id: '382313455864531217',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "What brings these jack-o-lanterns to life? Paper cups, orange and black paint, green pipe cleaners and a popsicle sick for the stem, tea light candles for a nose that glows, and your little one's imagination.",
              },
            ],
          },
          {
            id: '560346378633547956',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Mummies, monsters, Dracula, Frankenstein, oh my! Bring your old toilet paper or paper towel rolls back from the dead and the possibilities for cute and creepy decorations will be endless. Just add paint and other details—like glitter and googly eyes—as desired.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween decor ideas',
        sectionPins: [
          {
            id: '93871973468284797',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "I see a thrilling time in your future, as you put together one of these masterful (yet deceptively easy) DIY crystal balls. How, you ask? Hint: This project involves pairing holiday ornaments with ornate vintage candle holders. It's time to dig out your Christmas decorations and hit up some local thrift stores to find the exact right base for your ball.",
              },
            ],
          },
          {
            id: '71846556532952226',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Mason jars and monsters never looked so cute. Cheers to your new adorable Halloween cocktail glasses or table decorations.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'DIY Halloween decorations for outside',
        sectionPins: [
          {
            id: '330451691408985894',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'All signs point to Halloween. And all signs also point to this being one of the top photo opps of your yard.',
              },
            ],
          },
          {
            id: '354517801914590560',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Our 2019 Halloween insights show that searches for Halloween garage decorations are up 71%. Get ready for some double, double, toil, and trouble to recreate this Halloween display. ',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween door ideas',
        sectionPins: [
          {
            id: '99431104263295744',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "The front door isn't just for knocking and for asking for Halloween treats. It's for making a—haunting, creepy, or supernatural—first impression. ",
              },
            ],
          },
          {
            id: '84583299236827796',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'There are Christmas wreaths, and even Thanksgiving ones. But what your door deserves this holiday is this eye-popping DIY Halloween wreath.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Cheap Halloween decorations',
        sectionPins: [
          {
            id: '16888567339993177',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'White sheets + masking tape = your DIY crime scene. It’s budget friendly and you can throw it all together minutes before your party guests arrive. Nobody has to know. It’ll be our little secret.',
              },
            ],
          },
          {
            id: '466685580134441147',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'For another one-of-a-kind take on Halloween illumination, upcycle empty milk gallons into a string of ghoulish lights.',
              },
            ],
          },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          "It's that time of year. The spookiest. The craftiest. It's time for witches, ghosts, bats, pumpkins, and monsters. It's time for scissors, glue, markers, paint, and tape. It's time to decorate. To party. It's time for DIY and googly eyes. The creepier the better. The more budget-friendly the better. The more unique. The more grotesque. ",
      },
      {
        type: 'string',
        value:
          'The countdown to the big day—Halloween—is on. But you don’t need a lot of time, or money, to get your home, office, yard, or school looking like the scariest one around. All you need is a little creativity.',
      },
      {
        type: 'string',
        value:
          "You've come to the right place to get inspired. We've sifted through the best of Pinterest's tens of millions of boards filled with Halloween ideas, DIY Halloween props tutorials, and lists of cheap decorations you can make or buy. Here are some of our favorites: Halloween activities for kid, Halloween decor ideas, DIY Halloween decorations for outside, Halloween door ideas, Cheap Halloween decorations",
      },
      {
        type: 'string',
        value: "There's no time like the present to get started. Happy Halloween crafting!",
      },
    ],
  },
  '767300923952672104': {
    author: 'Pinterest Celebration',
    date: 'October 8, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: '11 Best Halloween Party Games, Treats, and More',
    introList: [
      {
        type: 'string',
        value:
          "What's not to love about Halloween parties? The fun,games, treats, and screams. Plus, for the hosts, there's the fun of planning and, of course, Pinning.",
      },
      {
        type: 'string',
        value:
          'Thanks to the collective creativity of our 300 million strong community, there are tens of millions of Pinterest boards filled with Halloween DIY guides for everything from haunted houses to tombstone toss games. Here are some of our favorite Halloween party ideas: Halloween activities, Halloween food ideas, DIY Halloween props, Halloween decoration ideas',
      },
    ],
    subsections: [
      {
        sectionName: 'Halloween activities',
        endText: [
          {
            type: 'string',
            value:
              "For even more ideas, check out our guide to 10 Halloween Crafts You'll Want to Pin (and Make), filled with bewitchingly creative Halloween activities for kids.",
          },
        ],
        sectionPins: [
          {
            id: '484207397437150151',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Pin the bowtie on the skeleton. Pop goes the pumpkin. Halloween-themed piñatas. Guess what's inside the mystery bowls. This one's packed with Halloween activities for kids. Now the only question is which one(s) will you choose for your party?",
              },
            ],
          },
          {
            id: '351912457355126',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Everyone's a ghost for Halloween with this crowd pleaser. It's a race to find all of the candy corn hiding in the whipped cream—but there's a catch, none of the players can use their hands. ",
              },
            ],
          },
          {
            id: '824721750494990312',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'For a morbid take on the classic lawn game cornhole, there\'s tombstone toss. Plus, discover tons of other do-it-yourself options, like the "eyeball dig" game (Hint: This one involves finding toy eyeballs hidden among cooked spaghetti). And what about prizes for the winners? There are step-by-step instructions for creating spooky skeleton trophies out of dollar-store finds.',
              },
            ],
          },
          {
            id: '786300416168164609',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Strike. Hole-in-one. Score. You've just won the party-planning lottery: 15 ideas for Halloween games for adults and kids. That's a win for you and your guests of all ages. Will you be as lucky when it's your turn to play?",
              },
            ],
          },
          {
            id: '525584219011401866',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Don't have the time or space for an elaborate game setup? How about Halloween Bingo? Print out these festive Bingo cards, substitute candy for Bingo tiles, and you and your guests will be good to go.",
              },
            ],
          },
          {
            id: '351912458930958',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'For this simple game that can be set up in seconds, all you need are two Halloween favorites: glow sticks and pumpkins. Pair them together, and you have your own holiday-themed, carnival-style ring toss.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween food ideas',
        endText: [
          {
            type: 'string',
            value:
              "For even more ideas to Pin, check out Pinterest's Top 13 Halloween Ideas, a round-up of even more DIY guides for Halloween treats, Halloween cakes, and more.",
          },
        ],
        sectionPins: [
          {
            id: '704531935433089539',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "For some sorcery in the kitchen, harness the power of Pinterest to transform Hershey's Kisses into witch hats, pretzel sticks and Reese's Peanut Butter Cups into witch brooms, and pretzel sticks into witch fingers. And that's just getting started on the list. Warning: These adorable finger foods may be just too cute to eat.",
              },
            ],
          },
          {
            id: '139470919695461387',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Of all the Halloween treats, this one truly takes the cake. For anyone planning a Halloween birthday party, make your special guest's wishes come true with this one-of-a-kind dish.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'DIY Halloween props',
        sectionPins: [
          {
            id: '605241637404214710',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Looking to scare up some fun with grown-up party guests? Haunted houses are trending this year, with searches up 267%, according to our 2019 holiday insights. Some Halloween party ideas for adults from this guide include: Staging a skeleton behind a decorated bar cart, Using a black light to illuminate creepy glow-in-the dark Halloween sayings, Hanging spooky Halloween pictures, Draping your walls with coverings and spider webs',
              },
            ],
          },
          {
            id: '446841594279860856',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Get the scoop on how to make your house look like it's straight out of a horror movie—complete with your own DIY murder scene, dead bodies, bloody candles, and more. Bonus points for pulling off these Harry Potter-inspired floating candles and assembling your own haunted mirrors.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween decoration ideas',
        sectionPins: [
          {
            id: '77264949842794924',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "This year 72% of Halloween shoppers plan to buy decorations, according to the National Retail Federation. But you don't have to spend a lot to surprise and delight and even startle and shock your party guests. Head to your nearest discount store then add your own personal spin on these party table settings, favors, and more.",
              },
            ],
          },
        ],
      },
    ],
    endText: [
      {
        type: 'string',
        value:
          "The countdown to the big day is on, so happy Pinning—and Halloween party planning! As you get going, don't forget to Pin your own Halloween party ideas on Pinterest.",
      },
      {
        type: 'string',
        value:
          'For more ways to celebrate, check out our other Halloween guides, curated from the tens of millions of holiday-themed Pinterest boards created by our 300 million strong community:',
      },
      {
        type: 'list',
        value: [
          {
            type: 'link',
            text: "10 Halloween Crafts You'll Want to Pin (and Make)",
            url: '/pinterest_celebrations/halloween-crafts/',
          },
          {
            type: 'link',
            text: 'Top 13 Halloween Ideas from Pinterest',
            url: '/pinterest_celebrations/halloween-ideas/',
          },
          {
            type: 'link',
            text: '13 Creative Halloween Costume Ideas for 2019',
            url: '/pinterest_celebrations/halloween-costumes/',
          },
        ],
      },
    ],
  },
  '767300923952672102': {
    author: 'Pinterest Celebration',
    date: 'October 8, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: '13 Creative Halloween Costume Ideas for 2019',
    introList: [
      {
        type: 'string',
        value:
          'It’s Halloween costume planning season. Time to celebrate what makes you unique. Your clever side. Your cool side. Your funny side. ',
      },
      {
        type: 'string',
        value:
          'Dressing up solo, with your best friend, a college group, the office, your whole family, as part of a duo or trio, while looking for easy Halloween costumes? Here are our top 13 favorite creative Halloween costume ideas for 2019.',
      },
    ],
    subsections: [
      {
        sectionName: 'DIY Halloween costumes',
        sectionPins: [
          {
            id: '158470480625678381',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Fruit Loops aren't your thing? Make this costume your own by substituting in your favorite brand. Use cookies for Cookie Crisp, brown balls for Reese's Puffs—the possibilities are endless.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'College Halloween costumes',
        sectionPins: [
          {
            id: '151715081184191824',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'This one\'s perfect for a group of friends from college or the office because everyone gets a say in just how spicy their individual costume will be. For a variation on the same "food group" theme, consider these related homemade Halloween costumes: spices Halloween group costume, candy bar Halloween group costume, and condiments Halloween group costume. ',
              },
            ],
          },
          {
            id: '51087777003174871',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Peace, love, groovy, far out. Harness your inner hippie flower child. Bonus points if you make your own tie-dye shirt and arrange your own DIY daisy chain crown. Get together with one friend, and you have a duo Halloween costume. Add another, and you have a trio. This idea can work for groups of any size.',
              },
            ],
          },
        ],
      },
      {
        sectionName:
          'Duo Halloween costumes, couple Halloween costumes, and best friend Halloween costumes',
        sectionPins: [
          {
            id: '415316396883922656',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Which is your favorite Scooby Doo duo? Grab your best friend or better half and pick a pair of characters from the hit show to dress up as. Daphne and Velma are trending this year, with searches for the two up 274% according to our insights. You can easily turn this duo costume into a group one and get the whole gang together.',
              },
            ],
          },
          {
            id: '824721750494922141',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Edgy. Dangerous. Wanted by the FBI. Live life on the wild side dressed up with your favorite partner in crime as Bonnie and Clyde—one of the most iconic villainous couples from history.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Teacher Halloween costumes',
        sectionPins: [
          {
            id: '201817627036961474',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Get the staff together and dress up as a box of Crayons—or take that one step further, and go all out as a set of school supplies. For other solo or group costume ideas for teachers, you can't go wrong with bringing your favorite storybook characters to life. The teachers who inspired this guide dressed up as the mouse from If You Give a Mouse a Cookie, The Grouchy Ladybug, and more.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Family Halloween costume ideas',
        sectionPins: [
          {
            id: '737042295244373155',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'The baby from The Hangover may be growing up, but if your little one still fits in a baby carrier, you can dress up as Alan and baby Carlos from the movie. Some other family ideas from this guide? The cast of Willy Wonka, a sushi meal, your favorite Toy Story characters, and more.',
              },
            ],
          },
          {
            id: '496310821431772404',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Superhero costumes are always a popular choice for people (and pets) of all ages. For families who want to dress up together, you can go as characters from Guardians of the Galaxy, as pictured here, or The Incredibles, The Avengers, Black Panther, Wonder Woman and more.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Baby Halloween costume ideas',
        sectionPins: [
          {
            id: '824721750495006702',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "It's a hotdog, a gumball machine, a gnome, a slice of pizza. It's 22 creative ways to dress up the baby of the family—before they start having an opinion about what they want to be for Halloween. If your little one will be in a baby carrier, consider turning these ideas into a duo costume for the two of you. For instance, if your baby dresses up as a slice of pizza, you can go as a chef.",
              },
            ],
          },
          {
            id: '158470480625796757',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "For your little one who's just starting to walk, here's a great option to give them a push to practice their skills with a stroll around the block during Halloween trick-or-treating. Plus, 99 other costume ideas for young ones of all ages.",
              },
            ],
          },
          {
            id: '790452172074955766',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'What goes together better than peanut butter and jelly? Your little ones dressed up in this easy-to-make DIY PB&J ensemble, of course. If you go out on Halloween, be prepared to have lots of people asking to take pictures with your family. ',
              },
            ],
          },
        ],
      },
      {
        sectionName: "Kids' Halloween costume ideas",
        sectionPins: [
          {
            id: '708120741386992958',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "For fans of Coco, dress your child up as the star, Miguel, or turn it into a family group costume, with everyone choosing different characters from the movie. To recreate Miguel's Day of the Dead-inspired look, you'll need Halloween makeup, a sweatshirt, jeans, boots, and his signature guitar.",
              },
            ],
          },
          {
            id: '123989795976300499',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Looking for something a little different than the traditional Halloween classics for kids? Among all the witches, ghosts, vampires, and pirates out trick-or-treating, your child can stand out dressed as a scuba diver, peacock, snail, bowl of Easy Mac, or any one of these 23 unique suggestions. ',
              },
            ],
          },
        ],
      },
    ],
    endText: [
      {
        type: 'string',
        value:
          'For more ways to celebrate, check out our other Halloween guides, curated from the tens of millions of holiday-themed Pinterest boards created by our community:',
      },
      {
        type: 'list',
        value: [
          {
            type: 'link',
            text: "10 Halloween Crafts You'll Want to Pin (and Make)",
            url: '/pinterest_celebrations/halloween-crafts/',
          },
          {
            type: 'link',
            text: 'Top 13 Halloween Ideas from Pinterest',
            url: '/pinterest_celebrations/halloween-ideas/',
          },
          {
            type: 'link',
            text: '11 Best Halloween Party Games, Treats, and More',
            url: '/pinterest_celebrations/halloween-parties/',
          },
        ],
      },
    ],
  },
  '767300923952672100': {
    author: 'Pinterest Celebration',
    date: 'October 8, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'Top 13 Halloween Ideas from Pinterest',
    introList: [
      {
        type: 'string',
        value:
          'On Halloween anyone can be an artist. In the kitchen—whipping up creepy and cute Halloween treats. Transforming every inch of the house, yard, front door, driveway, and garage with DIY Halloween props and spooky decor. Using pumpkin carving skills to craft next-level funny, cool, cute, and scary jack-o’-lantern faces. ',
      },
      {
        type: 'string',
        value:
          "It's no wonder the holiday inspires Pinterest's community members to get planning and Pinning at this time of year. In fact, there are already tens of millions of boards packed with Halloween ideas for everything from recipes for mummy dog appetizers to step-by-step instructions for how to make melting bloody hand candles.",
      },
      {
        type: 'string',
        value:
          "How do you narrow down all of that creativity into one ultimate list of the top 13 Halloween ideas? It's a daunting task. But we managed to do it. Here are our favorites.",
      },
    ],
    subsections: [
      {
        sectionName: 'Halloween food ideas, treats, recipes and cakes',
        sectionPins: [
          {
            id: '294000681920965831',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Store-bought candy has nothing on these whimsical, monstrous, and fantastic homemade Halloween treats—with options for every taste, such as cupcakes, puddings, cookies, brownies, and more. It won't all be sugar and spice. There is the daunting challenge of choosing which recipes to make.",
              },
            ],
          },
          {
            id: '267471665356273888',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Finger foods, how about frightening foods? You know what goes well with mummy dogs? Jalapeño popper mummies, one of the most-saved Halloween foods on Pinterest last year. ',
              },
            ],
          },
          {
            id: '744993963335951359',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'This is one brain food that may be too perfectly grotesque to eat. Be sure to stick a knife in the dessert to create a truly terrifying look. Take pictures of your final product, then let your guests eat their hearts—or the brain cake—out.',
              },
            ],
          },
          {
            id: '61150507441302396',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "It's what's on the inside that counts. Cut into this elegant black and orange cake to reveal a colorful candy corn core. Note: Behind the scenes work will include creating six separate cake layers, three black and three white cake layers—with one remaining white and the others colored yellow and orange to achieve the candy corn surprise shape inside. If you like cake reveals, pumpkin piñata cakes are also a thing. When you cut inside these cakes, Halloween candies spill out instead of pumpkin seeds.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween DIY',
        sectionPins: [
          {
            id: '629448485400077951',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Haunted houses are trending on Pinterest this year. With an eye for detail and a knack for putting together unnerving, hair-raising decor—such as these hanging cages pictured here, you too can transform your home into a scary scene this Halloween.',
              },
            ],
          },
          {
            id: '545920786072585361',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'DIY spider web balls—horrifying, or the perfect addition to your Halloween yard decorations? This guide has tons of other ideas for outdoors and indoors, including Halloween door themes, floating witch hat displays, and more.',
              },
            ],
          },
          {
            id: '642537071814547611',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Needed: Mason jar(s), fake eyeballs, and a red food coloring and water concoction (or a red drink). And, voilà, you have one or many DIY Halloween props perfect for creeping out your Halloween party guests.',
              },
            ],
          },
          {
            id: '315463148898685311',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Contrasts between light and dark and night and day have long been a part of Halloween celebrations throughout time, dating back to the ancient origins of the holiday thousands of years ago. To this day, fires and candles remain part of our rituals. In modern times, however, we have more types of illumination than ever to choose from—such as this bleeding hand candle.',
              },
            ],
          },
          {
            id: '412149803400295690',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'It\'s the little things that can make a big difference. Even small spaces, such as apartments or entry-ways, can take on a new life at Halloween. Turn your bookcases into "boo" cases, by covering the whole thing from top to bottom in ghosts, spider webs, bats, and more. ',
              },
            ],
          },
          {
            id: '741123682411919093',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "From the front door to the fridge door, from the table centerpiece to the walls, the possibilities for places and ways to decorate for Halloween are endless. Ready for your next DIY project to tackle? This cute, classic jack-o'-lantern craft is one of 25 to keep you busy until October 31st, 2019 (and maybe even until October 31, 2020). ",
              },
            ],
          },
          {
            id: '626844841867725133',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'For a modern take on the classic Halloween decorations of skeletons and spiders, consider recreating this humorous backyard scene. Or take things a step further by reversing the roles—with extra-large spiders taking miniature skeletons on a walk. ',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Pumpkin carving ideas',
        sectionPins: [
          {
            id: '439945457350365977',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'You can read the pure terror in this poor pumpkin’s eyes as a group of cannibal mini-pumpkins attempt to eat it to pieces. Now, how to recreate this one-of-a-kind pumpkin carving idea and make it your own?',
              },
            ],
          },
          {
            id: '560416747381963393',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Who knew that adding string to jack-o'-lantern faces could have such a chilling effect? Also scary? Opting for a design with one eye, no eyes, super small eyes, and oversized eyes. For those searching for fun or cute pumpkin carving ideas, this guide also includes an It's the Great Pumpkin, Charlie Brown scene, as well as pumpkin carving examples inspired by The Wizard of Oz and Disney.",
              },
            ],
          },
        ],
      },
    ],
    endText: [
      {
        type: 'string',
        value:
          'Happy Halloween—however you ultimately choose to celebrate the holiday and your own creativity! As you get started, be sure to Pin your Halloween recipes, DIY decorations, pumpkin carving tips, and more to share with the Pinterest community.',
      },
      {
        type: 'string',
        value:
          'For more ways to celebrate, check out our other Halloween guides, curated from the tens of millions of holiday-themed Pinterest boards created by our community:',
      },
      {
        type: 'list',
        value: [
          {
            type: 'link',
            text: "10 Halloween Crafts You'll Want to Pin (and Make)",
            url: '/pinterest_celebrations/halloween-crafts/',
          },
          {
            type: 'link',
            text: '13 Creative Halloween Costume Ideas for 2019',
            url: '/pinterest_celebrations/halloween-costumes/',
          },
          {
            type: 'link',
            text: '11 Best Halloween Party Games, Treats, and More',
            url: '/pinterest_celebrations/halloween-parties/',
          },
        ],
      },
    ],
  },
};
